
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"20","cy":"20","r":"20","fill":"#000"}}),_c('path',{attrs:{"d":"M22.766 21.554c.022.04.046.08.073.115L24 27.823 16 30V16.057l3.373-1.287c1.427 2.879 3.393 6.784 3.393 6.784zm4.338-5.782l.74.32L33 29.331l-7.416-1.54-1.226-6.543c.435-.865 1.713-3.405 2.746-5.477zM14.392 15.932V30L7 27.947 9.43 14l4.962 1.932zM22.9 18.659c.254.455.954.455 1.176 0 0 0 2.799-5.191 3.435-6.435.636-1.214.668-2.61 0-3.854-1.113-2.125-3.816-2.975-6.042-1.913-2.226 1.063-3.085 3.734-2.004 5.767 1.08 2.064 3.435 6.435 3.435 6.435zM23.5 8c1.386 0 2.5 1.115 2.5 2.5 0 1.386-1.115 2.5-2.5 2.5a2.494 2.494 0 01-2.5-2.5C21 9.115 22.114 8 23.5 8z","fill":"#FFF","fill-rule":"nonzero"}})])])
          )
        }
      }
    